import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type CultureInfo from "../../culture-info";
import { AggregationRequestResource } from "./aggregation-request-resource";
import { FieldFilterRequestResource } from "./field-filter-request-resource";
import { NestedRelationInfo } from "./nested-relation-info";
import { SearchGroupRequestResource } from "./search-group-request-resource";
import { SelectionPoolFilterResource } from "./selection-pool-filter-resource";
import { SortingRequestResource } from "./sorting-request-resource";
import { VisualSearchRequestResource } from "./visual-search-request-resource";

export interface ISearchRequest {
    view: string;
    configurationCategory?: string;
    searchDefaults?: string;
    componentId?: number;
    culture: CultureInfo;
    take: number;
}

@JsonObject()
export class SearchRequest implements ISearchRequest {
    @JsonProperty("query")
    query: string;

    @JsonProperty("logical_grouping_template")
    logicalGroupingTemplate?: string;

    @JsonProperty("defaults")
    searchDefaults?: string;

    @JsonProperty("configuration_category")
    configurationCategory?: string;

    @JsonProperty("component")
    componentId?: number;

    @JsonProperty("culture")
    culture: CultureInfo = "Invariant";

    @JsonProperty("sorting")
    sorting?: SortingRequestResource;

    @JsonProperty("skip")
    skip?: number = 0;

    @JsonProperty("take")
    take: number;

    @JsonProperty("filters")
    @JsonElementType(FieldFilterRequestResource)
    fieldFilters: Array<FieldFilterRequestResource> = [];

    @JsonProperty("fulltext")
    @JsonElementType(String)
    fullTextFilters: Array<string> = [];

    @JsonProperty("fields")
    @JsonElementType(String)
    fields: Array<string> = [];

    @JsonProperty("saved_selection")
    savedSelection?: number;

    @JsonProperty("view")
    view: string;

    @JsonProperty("calendarStartDate")
    calendarStartDate?: Date | string;

    @JsonProperty("calendarStopDate")
    calendarStopDate?: Date | string;

    @JsonProperty("selection_pool")
    selectionPool?: SelectionPoolFilterResource;

    @JsonProperty("aggregations")
    @JsonElementType(AggregationRequestResource)
    aggregations: Array<AggregationRequestResource> = [];

    @JsonProperty("nested_relations")
    @JsonElementType(NestedRelationInfo)
    nestedRelations?: Array<NestedRelationInfo>;

    @JsonProperty("group")
    group?: SearchGroupRequestResource;

    @JsonProperty("is_initial_request")
    isInitialRequest?: boolean = false;

    @JsonProperty("take_user_settings")
    takeUserSettings?: boolean = false;

    @JsonProperty("details_entity_id")
    detailsEntityId?: number;

    @JsonProperty("l10n")
    l10n?: boolean;

    @JsonProperty("visualSearch")
    visualSearch?: VisualSearchRequestResource;

    //? Extension data

    constructor(init?: Partial<SearchRequest>) {
        Object.assign(this, init);
    }
}
